import * as React from 'react'

import { FoldersPageHeaderDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const FoldersPageHeader = React.lazy(
  () => import('modules/documents/pages/employees/FoldersPage/FoldersPageHeader')
)

const DocumentsListPage = React.lazy(
  () => import('modules/documents/pages/employees/DocumentsListPage')
)
const FoldersPage = React.lazy(() => import('modules/documents/pages/employees/FoldersPage'))
const NavigateToDocumentsPage = React.lazy(
  () => import('modules/documents/pages/employees/NavigateToDocumentsPage')
)
const NewDocumentPage = React.lazy(
  () => import('modules/documents/pages/employees/NewDocumentPage')
)
const NewFolderDocumentPage = React.lazy(
  () => import('modules/documents/pages/employees/NewFolderDocumentPage')
)
const RootPage = React.lazy(() => import('modules/documents/pages/employees/RootPage'))
const DocumentViewerPage = React.lazy(() => import('modules/documents/pages/DocumentViewerPage'))

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.employees.id.documents.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <NavigateToDocumentsPage />,
        },
        {
          path: navigation.employees.id.documents.list.path,
          element: <DocumentsListPage />,
          children: [
            {
              path: navigation.employees.id.documents.list.new.path,
              element: <NewDocumentPage />,
            },
            {
              path: navigation.employees.id.documents.list.documentId.path,
              element: <DocumentViewerPage />,
            },
          ],
        },
        {
          path: navigation.employees.id.documents.folderId.path,
          element: <FoldersPage />,
          handle: {
            resource: true,
            meta: ({ params, watchQuery }) => {
              if (!params['folderId']) return { title: '' }
              return watchQuery({
                query: FoldersPageHeaderDocument,
                variables: {
                  employeeId: String(params['id']),
                  folderId: String(params['folderId']),
                },
              }).map(({ data }) => {
                const folder = data?.documents?.foldersConnection?.edges[0]?.node
                const title = folder ? folder.name : ''

                const employee = data?.employees?.employee

                const ancestors = [
                  {
                    title: i18n.t('sidebar.documents'),
                    to: navigation.employees.id.documents.list.fullPath({
                      id: String(params['id']),
                    }),
                  },
                ]
                data?.documents?.ancestors?.edges
                  ?.map((edge) => edge.node)
                  ?.forEach((node) => {
                    ancestors.push({
                      title: node.name,
                      to: navigation.employees.id.documents.folderId.fullPath({
                        id: String(params['id']),
                        folderId: node.id,
                      }),
                    })
                  })

                return {
                  title,
                  ancestors,
                  headerComponent: folder ? (
                    <FoldersPageHeader employee={employee} folder={folder} />
                  ) : null,
                }
              })
            },
          },
          children: [
            {
              path: navigation.employees.id.documents.folderId.new.path,
              element: <NewFolderDocumentPage />,
            },
            {
              path: navigation.employees.id.documents.folderId.documentId.path,
              element: <DocumentViewerPage />,
            },
          ],
        },
      ],
    },
  ]
}

export default employeesRoutes
